import { css } from '@emotion/core';
export var inspections = {
  name: "19idom",
  styles: "margin-bottom:8px;"
};
export var noInspections = {
  name: "i3pbo",
  styles: "margin-bottom:24px;"
};
export var popupContainerOuter = {
  name: "79elbk",
  styles: "position:relative;"
};
export var popupContainerInner = _ref => {
  var top = _ref.top,
    left = _ref.left;
  return /*#__PURE__*/css("position:absolute;top:", top, "px;left:", left, "px;");
};